export default {
  Substitute: 'Người nộp thay',
  Address: 'Địa chỉ',
  District: 'Huyện',
  Province: 'Tỉnh, TP',
  BankName: 'Đề nghị NH (KBNN)',
  BankAcocunt: 'Trích TK số',
  SubmitNSNN: 'Nộp vào NSNN',
  TemporaryCollection: 'TK tạm thu',
  TaxRefund: 'TK thu hồi quỹ hoàn thuế GTGT',
  StateTreasuryName: 'Tại KBNN',
  StreasuryProvince: 'Tỉnh, TP',
  AddressOpening: 'Mở tại NHTM UN thu',
  OtherCase: 'Trường hợp nộp theo kết luận của CQ có thẩm quyền',
  StateAudit: 'Kiểm toán nhà nước',
  InspectTC: 'Thanh tra TC',
  InspectCP: 'Thanh tra CP',
  OtherOrgan: 'CQ có thẩm quyền khác',
  OrgAgencyName: 'Tên CQ quản lý thu',
  DecalrationNumber: 'Tờ khai HQ, QĐ số',
  Day: 'Ngày',
  OrgAgencyCode: 'Mã CQ quản lý thu',
  CashTo: 'Hoặc thu tiền mặt để',
};
